import React, { useLayoutEffect, useState } from "react";

/**
 * Applica il design della variante Power Prescription aggiungendo la classe `pp`
 * al body (#kt_body) quando REACT_APP_POWER_PRESCRIPTION_DESIGN === "true".
 *
 * - Power Prescription (true): aggiunge la classe `pp` e renderizza i children
 *   SOLO dopo che la classe è stata applicata (evita flash del design Service Go).
 * - Service Go (default/false): renderizza subito i children.
 */
const DesignLoad: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const isPowerPrescription = process.env.REACT_APP_POWER_PRESCRIPTION_DESIGN === "true";
    const [ready, setReady] = useState<boolean>(!isPowerPrescription);

    useLayoutEffect(() => {
        if (isPowerPrescription) {
            const body = document.getElementById("kt_body");
            if (body && !body.classList.contains("pp")) {
                body.classList.add("pp");
            }
            setReady(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <>{ready && children}</>;
};

export default DesignLoad;
